export const PARAM_PHONE_NUMBER = 'sdkPhoneNumber'

// Query params
export const PARAM_IS_HEADER_MINI_APP = 'isHeaderMiniApp'
export const PARAM_IS_HEADER_MINI_APP_EXPAND = 'isHeaderMiniAppExpand'
export const PARAM_IS_EMBEDDED_VIEW = 'isEmbeddedView'
export const PARAM_APIKEY = 'apikey' // apikey cố định mặc định cho app chứ ko phải để chuyển link
export const PARAM_SHOW_PHONE_INPUT = 'showPhoneInput'
export const PARAM_SHOW_BANNER_IN_EMBEDDED_VIEW = 'showBannerInEmbeddedView'
export const PARAM_APP_THEME_NAME = 'appThemeName'
export const PARAM_PARTNER_NAME = 'partnerName'
export const PARAM_IS_SELECT_VEHICLE_TYPE_USE_ICON = 'isSelectVehicleTypeUseIcon'
export const PARAM_IS_TBPN_SELECT_VEHICLE_TYPE_WITH_ELECTRIC_MOTOBIKE = 'isTBPNSelectVehicleTypeWithElectricMotobike'
export const PARAM_IS_BACK_TO_HOME_MINI_APP = 'isBackToHomeMiniApp'

export const MESSAGE_BACK_TO_HOME_MINI_APP = 'BackToHomeMiniApp'
